export enum QCActionExecutor {
  None = 0,
  SalesForce = 1,
}
